export const environment = {
  production: false,
  apiUrl: 'https://services.dev.blue-sail.net/oms',
  clientId: 'oms-frontend-api',
  clientSecret: 'password'
};
